export class StudentLearningProcess {
    id: number;

    studentId: number;
    schoolId : number;

    staffId : number;
    fullName : string;

    courseId: number;
    courseName: string;

    classCourseId: number;
    studyingClassYear: string;
    managerName : string;
    managerId : number;

    resultId: number;
    resultName: string;

    achievementId: number;
    achievementName: string;
    studyProgramId: number;
    educationalStatusId: number;

    note: string;
    educationalStatusName: string;
    schoolName: string;
    staffName: string;
    chuongTrinhHocName: string;
    schoolLevelId : number;
} 